import { Services } from '@smiles/voebiz-core-corporate-club';
import { IAddPurchaseMilesByBeneficiaryRequest } from '@smiles/voebiz-core-corporate-club/dist/Types/AddPurchaseMilesByBeneficiaryApi.types';
import { IGetBeneficiaryPurchaseMilesRequest } from '@smiles/voebiz-core-corporate-club/dist/Types/GetBeneficiaryPurchaseMilesApi.types';
import { IListPurchaseMilesParams } from '@smiles/voebiz-core-corporate-club/dist/Types/GetListPurchaseMiles.types';
import { IUploadBatchPurchaseMilesRequest } from '@smiles/voebiz-core-corporate-club/dist/Types/UploadBatchPurchaseMilesApi.types';

interface UploadBatchPurchaseMiles extends IUploadBatchPurchaseMilesRequest {
  isClient: boolean;
}

interface AddPurchaseMilesByBeneficiary extends IAddPurchaseMilesByBeneficiaryRequest {
  isClient: boolean;
}

interface GetBeneficiaryPurchaseMiles extends IGetBeneficiaryPurchaseMilesRequest {
  isClient: boolean;
}

export async function mockGetStatus() {
  return new Promise<boolean>((resolve) => {
    setTimeout(() => {
      resolve(true);
      return true;
    }, 2000);
  });
}

// serviço que recebe a lista de Transações
export async function getTransactionsList(params: IListPurchaseMilesParams) {
  console.log('caiu na transctions');
  console.log('params na transctions: ', params);
  console.log('return da transactions: ', Services.getListPurchaseMiles(params));
  return Services.getListPurchaseMiles(params);
}

// Serviço pra enviar o CSV  e o nome da campanha em lote
export async function postCSVFileAndCampaingName(file: string, campaignName: string, isClient: boolean) {
  return Services.uploadBatchPurchaseMiles({
    file,
    fileName: file,
    campaignName,
    attributionType: 'Lote',
    isClient,
  } as UploadBatchPurchaseMiles);
}

// Serviço pra enviar o Form para transação individual
export async function postFormIndividual(
  memberBeneficiaryCPF: string,
  miles: string,
  campaignName: string,
  isClient: boolean,
) {
  return Services.addPurchaseMilesByBeneficiary({
    memberBeneficiaryCPF,
    miles,
    campaignName,
    isClient,
  } as AddPurchaseMilesByBeneficiary);
}

// Serviço que recebe o min e o max de milhas pra transferir
export async function getMinAndMaxMiles() {
  const result = await Services.getParametersPurchaseMiles();
  return {
    minMiles: result?.data?.minLimit,
    maxMiles: result?.data?.maxLimit,
    activeForTeam: result?.data?.activeForTeam,
    activeForClients: result?.data?.activeForClients,
  };
}

// Serviço que consulta se o CPF já está cadastrado na base de dados
export async function searchRegisterCPF(cpfValue: string, isClient: boolean) {
  return Services.getBeneficiaryPurchaseMiles({
    memberBeneficiaryCPF: cpfValue,
    isClient,
  } as GetBeneficiaryPurchaseMiles);
}
